import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { MenuContainer, MenuItem, PaymentCardIcon } from './styles';

interface Props {
  closeMenu: () => void;
  isDefault?: boolean;
  onRemove: () => void;
  onSetAsDefault?: () => void;
  onLinkToGroup?: () => void;
}

const PopoverMenu = ({ closeMenu, isDefault, onRemove, onSetAsDefault, onLinkToGroup }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <MenuContainer>
      {isDefault ? null : (
        <>
          <MenuItem
            onClick={() => {
              closeMenu();
              if (onSetAsDefault) {
                onSetAsDefault();
              }
            }}
          >
            <PaymentCardIcon />
            <MenuItem.Title>{t('payment.paymentCardGroup.menu.setAsDefault')}</MenuItem.Title>
          </MenuItem>
          <MenuItem
            onClick={() => {
              closeMenu();
              if (onLinkToGroup) {
                onLinkToGroup();
              }
            }}
          >
            <MenuItem.Icon src="/images/payment/menu-group-assign.svg" alt="" />
            <MenuItem.Title>{t('payment.paymentCardGroup.menu.setGroups')}</MenuItem.Title>
          </MenuItem>
        </>
      )}
      <MenuItem
        onClick={() => {
          closeMenu();
          onRemove();
        }}
      >
        <MenuItem.Icon src="/images/payment/menu-remove-card.svg" alt="" />
        <MenuItem.Title>{t('payment.paymentCardGroup.menu.removeCard')}</MenuItem.Title>
      </MenuItem>
    </MenuContainer>
  );
};
export default PopoverMenu;
